import { LetterContentEditor } from 'assets/js/pages/engage/letters/LetterContentEditor';
import { usePersonalizedLettersStore } from 'assets/js/pages/engage/letters/usePersonalizedLettersStore';

const PersonalizedLetterWysiwyg = () => {
    const {
        currentPersonalizedLetterContact: contact,
        setEditorInstance,
        setHasDiffFromMasterLetter,
    } = usePersonalizedLettersStore();

    if (!contact) {
        return null;
    }

    return (
        <LetterContentEditor
            key={contact.id}
            autoSave={false}
            contactId={contact.id}
            editorProps={{
                onInit: (_, editor) => setEditorInstance(editor),
                onEditorChange: (_, editor) => {
                    setHasDiffFromMasterLetter(editor.isDirty());
                },
            }}
        />
    );
};

export { PersonalizedLetterWysiwyg };
